module.exports = __webpack_public_path__ + "media/images/piesync-32bf4c6b1473a728a60587959b051240.svg";